// ** Modules
import { createBreakpoints } from '@mui/system';

// ** Types
import type { Breakpoint, Breakpoints } from '@mui/material/styles';

const breakpoints: Breakpoints = createBreakpoints({
	keys: ['xs', 'sm', 'md', 'lg', 'xl'] as Breakpoint[], // Explicitly cast keys to Breakpoint[]
	values: {
		xs: 0,
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1700
	}
});

export default breakpoints;
